import React, { useState } from 'react';

const InnovationPage = () => {
  const [activeTab, setActiveTab] = useState('oneriler');
  const [showSubmitForm, setShowSubmitForm] = useState(false);
  const [formData, setFormData] = useState({
    baslik: '',
    kategori: '',
    aciklama: '',
    dosya: null
  });

  // Sample suggestions data
  const suggestions = [
    {
      id: 1,
      title: "Yapay Zeka Destekli Proje Planlama",
      author: "Mehmet Özkan",
      department: "AR-GE",
      date: "2025-07-15",
      category: "Teknoloji",
      status: "Değerlendiriliyor",
      votes: 47,
      description: "Proje planlaması süreçlerinde yapay zeka algoritmalarının kullanılması...",
      impact: "Yüksek"
    },
    {
      id: 2,
      title: "Çevre Dostu Beton Karışımı",
      author: "Ayşe Demir",
      department: "Malzeme Mühendisliği",
      date: "2025-07-10",
      category: "Sürdürülebilirlik",
      status: "Uygulanıyor",
      votes: 89,
      description: "Geri dönüştürülmüş malzemelerle üretilen yeni nesil beton karışımı...",
      impact: "Çok Yüksek"
    },
    {
      id: 3,
      title: "Mobil Güvenlik Kontrol Sistemi",
      author: "Can Tekin",
      department: "İş Güvenliği",
      date: "2025-07-08",
      category: "Güvenlik",
      status: "Kabul Edildi",
      votes: 63,
      description: "Şantiye güvenlik kontrollerinin mobil uygulama üzerinden yapılması...",
      impact: "Orta"
    }
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFileChange = (e) => {
    setFormData(prev => ({
      ...prev,
      dosya: e.target.files[0]
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Öneriniz başarıyla gönderildi! Değerlendirme sürecinden geçtikten sonra size dönüş yapılacaktır.');
    setFormData({ baslik: '', kategori: '', aciklama: '', dosya: null });
    setShowSubmitForm(false);
  };

  const getStatusColor = (status) => {
    const colors = {
      'Değerlendiriliyor': 'bg-warning',
      'Uygulanıyor': 'bg-info',
      'Kabul Edildi': 'bg-success',
      'Reddedildi': 'bg-danger'
    };
    return colors[status] || 'bg-secondary';
  };

  const getImpactColor = (impact) => {
    const colors = {
      'Çok Yüksek': 'text-danger',
      'Yüksek': 'text-warning',
      'Orta': 'text-info',
      'Düşük': 'text-secondary'
    };
    return colors[impact] || 'text-secondary';
  };

  return (
    <div className="container-fluid">
      {/* Header */}
      <div className="row mb-4">
        <div className="col-12">
          <div className="box">
            <div className="box-body text-center">
              <i className="bx bx-bulb display-1 text-primary mb-3"></i>
              <h2>İnovasyon ve Öneri Kutusu</h2>
              <p className="text-muted">
                Şirketimizi daha iyi hale getirmek için fikirlerinizi paylaşın. 
                Her öneri değerlendirilir ve uygun olanlar uygulanır.
              </p>
              <button 
                className="btn btn-primary btn-lg"
                onClick={() => setShowSubmitForm(true)}
              >
                <i className="bx bx-plus-circle me-2"></i>
                Yeni Öneri Gönder
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Submit Form Modal */}
      {showSubmitForm && (
        <div className="row mb-4">
          <div className="col-12">
            <div className="box">
              <div className="box-header">
                <div className="d-flex justify-content-between align-items-center">
                  <h4 className="card-title">Yeni Öneri Gönder</h4>
                  <button 
                    className="btn btn-sm btn-outline-secondary"
                    onClick={() => setShowSubmitForm(false)}
                  >
                    <i className="bx bx-x"></i>
                  </button>
                </div>
              </div>
              <div className="box-body">
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Öneri Başlığı <span className="text-danger">*</span></label>
                        <input 
                          type="text" 
                          className="form-control" 
                          name="baslik"
                          value={formData.baslik}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label className="form-label">Kategori <span className="text-danger">*</span></label>
                        <select 
                          className="form-select" 
                          name="kategori"
                          value={formData.kategori}
                          onChange={handleInputChange}
                          required
                        >
                          <option value="">Kategori seçiniz...</option>
                          <option value="Teknoloji">Teknoloji</option>
                          <option value="Sürdürülebilirlik">Sürdürülebilirlik</option>
                          <option value="Güvenlik">Güvenlik</option>
                          <option value="Verimlilik">Verimlilik</option>
                          <option value="Kalite">Kalite</option>
                          <option value="İnsan Kaynakları">İnsan Kaynakları</option>
                          <option value="Diğer">Diğer</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Öneri Açıklaması <span className="text-danger">*</span></label>
                    <textarea 
                      className="form-control" 
                      rows="5"
                      name="aciklama"
                      value={formData.aciklama}
                      onChange={handleInputChange}
                      placeholder="Önerinizi detaylı şekilde açıklayın..."
                      required
                    ></textarea>
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Dosya Ekle (İsteğe bağlı)</label>
                    <input 
                      type="file" 
                      className="form-control" 
                      name="dosya"
                      onChange={handleFileChange}
                      accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                    />
                    <div className="form-text">PDF, Word belgeleri veya görsel dosyalar ekleyebilirsiniz.</div>
                  </div>
                  <div className="d-flex justify-content-end gap-2">
                    <button 
                      type="button" 
                      className="btn btn-outline-secondary"
                      onClick={() => setShowSubmitForm(false)}
                    >
                      İptal
                    </button>
                    <button type="submit" className="btn btn-primary">
                      <i className="bx bx-send me-1"></i>
                      Gönder
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Tabs */}
      <div className="row">
        <div className="col-12">
          <div className="box">
            <div className="box-header">
              <ul className="nav nav-pills nav-justified">
                <li className="nav-item">
                  <button 
                    className={`nav-link ${activeTab === 'oneriler' ? 'active' : ''}`}
                    onClick={() => setActiveTab('oneriler')}
                  >
                    <i className="bx bx-list-ul me-1"></i>
                    Tüm Öneriler
                  </button>
                </li>
                <li className="nav-item">
                  <button 
                    className={`nav-link ${activeTab === 'populer' ? 'active' : ''}`}
                    onClick={() => setActiveTab('populer')}
                  >
                    <i className="bx bx-trending-up me-1"></i>
                    Popüler Öneriler
                  </button>
                </li>
                <li className="nav-item">
                  <button 
                    className={`nav-link ${activeTab === 'uygulanan' ? 'active' : ''}`}
                    onClick={() => setActiveTab('uygulanan')}
                  >
                    <i className="bx bx-check-circle me-1"></i>
                    Uygulanan Öneriler
                  </button>
                </li>
              </ul>
            </div>

            <div className="box-body">
              <div className="row">
                {suggestions.map(suggestion => (
                  <div key={suggestion.id} className="col-lg-6 col-md-12 mb-4">
                    <div className="box h-100">
                      <div className="box-body">
                        <div className="d-flex justify-content-between align-items-start mb-3">
                          <h5 className="card-title">{suggestion.title}</h5>
                          <div className="d-flex align-items-center">
                            <button className="btn btn-sm btn-outline-primary me-2">
                              <i className="bx bx-up-arrow"></i> {suggestion.votes}
                            </button>
                            <span className={`badge ${getStatusColor(suggestion.status)}`}>
                              {suggestion.status}
                            </span>
                          </div>
                        </div>
                        
                        <p className="text-muted mb-3">{suggestion.description}</p>
                        
                        <div className="row mb-3">
                          <div className="col-6">
                            <small className="text-muted">
                              <i className="bx bx-user me-1"></i>
                              {suggestion.author}
                            </small>
                          </div>
                          <div className="col-6 text-end">
                            <small className="text-muted">
                              <i className="bx bx-calendar me-1"></i>
                              {suggestion.date}
                            </small>
                          </div>
                        </div>
                        
                        <div className="d-flex justify-content-between align-items-center">
                          <div>
                            <span className="badge bg-light text-dark me-2">{suggestion.category}</span>
                            <span className={`badge bg-light ${getImpactColor(suggestion.impact)}`}>
                              {suggestion.impact} Etki
                            </span>
                          </div>
                          <div>
                            <button className="btn btn-sm btn-outline-primary me-1">
                              <i className="bx bx-comment"></i>
                            </button>
                            <button className="btn btn-sm btn-outline-primary">
                              <i className="bx bx-share"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InnovationPage;
